import { ActionReducerMap } from '@ngrx/store';
import { ReceivingReducer } from './receiving-reducer';

export const appReducers: ActionReducerMap<any> = {
    Receiving: ReceivingReducer
};